import React from 'react';
import { Box, Button, Container, Typography } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const HeroSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        background: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url('https://images.unsplash.com/photo-1560066984-138dadb4c035?w=1920&h=1080&fit=crop')`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        color: 'white',
        py: { xs: 10, md: 20 },
        textAlign: 'center',
        position: 'relative',
      }}
    >
      <Container maxWidth="md">
        <Typography
          variant="h1"
          component="h1"
          sx={{
            fontSize: { xs: '2.5rem', md: '4rem' },
            fontWeight: 600,
            mb: 2,
            textShadow: '2px 2px 4px rgba(0, 0, 0, 0.5)',
          }}
        >
          Desiree Braiding
        </Typography>
        <Typography
          variant="h5"
          sx={{
            mb: 4,
            fontWeight: 400,
            maxWidth: '800px',
            mx: 'auto',
            textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
          }}
        >
          {t('hero.tagline')}
        </Typography>
        <Box
          sx={{
            display: 'flex',
            flexDirection: { xs: 'column', sm: 'row' },
            justifyContent: 'center',
            gap: 2,
          }}
        >
          <Button
            component={RouterLink}
            to="/booking"
            variant="contained"
            color="primary"
            size="large"
            sx={{
              fontSize: '1.1rem',
              py: 1.5,
              px: 4,
              fontWeight: 500,
              color: 'text.primary',
            }}
          >
            {t('hero.bookNow')}
          </Button>
          <Button
            component={RouterLink}
            to="/services"
            variant="outlined"
            size="large"
            sx={{
              fontSize: '1.1rem',
              py: 1.5,
              px: 4,
              fontWeight: 500,
              borderColor: 'white',
              color: 'white',
              '&:hover': {
                borderColor: 'white',
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            {t('hero.ourServices')}
          </Button>
        </Box>
      </Container>
    </Box>
  );
};

export default HeroSection;
